<template>
  <ChatMotion
    v-if="user"
    :value="size"
  >
    <VueDraggableResizable
      slot-scope="{ value }"
      :x="x"
      :y="y"
      :resizable="false"
      :draggable="!isMobile"
      :w="w"
      :h="isMobile ? 44 : 89"
      :class="{ 'has-shadow': !open, 'is_visible': open }"
      class-name="chat-container"
      parent="#app"
      drag-cancel=".drag-cancel"
      @dragging="dragging = true"
      @dragstop="onDragstop"
    >
      <ChatHeader
        :open="open"
        @click="toggleChat"
      />
      <div>
        <ChatMessages
          v-chat-scroll
          :style="{ height: `${value}px` }"
          :messages="messages"
        />
        <ChatInput
          :is-open="open"
          @enter="sendMessage"
        />
      </div>
      <ChatFooter
        v-if="false"
        :is-open="open"
        @click="open = !open"
      />
    </VueDraggableResizable>
  </ChatMotion>
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import { Motion } from 'vue-motion'
import VueDraggableResizable from 'vue-draggable-resizable'
import ChatHeader from './ChatHeader'
import ChatFooter from './ChatFooter'
import ChatInput from './ChatInput'
import ChatMessages from './ChatMessages'

export default {
  name: 'ChatWindow',

  components: {
    ChatHeader,
    ChatFooter,
    ChatInput,
    ChatMessages,
    ChatMotion: Motion,
    VueDraggableResizable,
  },

  data() {
    return {
      open: false,
      dragging: false,
      messages: [],
    }
  },

  computed: {
    ...mapGetters({
      x: 'global/chatX',
      y: 'global/chatY',
      w: 'global/chatWidth',
      isMobile: 'global/isMobile',
      maxHeight: 'global/chatMaxHeight',
      currentEpisode: 'auth/currentEpisode',
      username: 'auth/username',
    }),

    size() {
      return this.open ? this.maxHeight : 0
    },

    ...mapState({
      user: state => state.auth.user,
      dark: state => state.auth.dark,
      width: state => state.global.screenWidth,
      height: state => state.global.screenHeight,
    }),
  },

  methods: {
    close() {
      this.open = false
    },

    onDragstop() {
      setTimeout(() => {
        this.dragging = false
      }, 10)
    },

    toggleChat() {
      if (this.dragging) {
        return
      }
      this.open = !this.open
    },

    sendMessage(message) {
      this.addMessage({ text: message, who: `USER ${this.username}` })

      const data = {
        driver: 'web',
        message,
        episode: this.currentEpisode,
      }

      axios.post(`${process.env.VUE_APP_BOT_SERVER}/botman`, data).then(response => {
        const messages = response.data.messages || []

        let lastMessage = null
        let messageLength = 1000

        for (let i = 0; i <= messages.length; i++) {
          const msg = messages[i]

          setTimeout(() => {
            // remove loading from last message
            if (lastMessage) {
              lastMessage.loading = false
            }
            // add new message
            if (msg) {
              const messageId = this.addMessage({ text: msg.text, who: 'PATRICIA' })
              lastMessage = this.messages.find(m => m.id === messageId)
            }
          }, messageLength * i)
        }
      })
    },

    addMessage({ text, who }) {
      const id = Math.random() * 10000000
      this.messages.push({
        id,
        text,
        who,
        loading: who === 'PATRICIA',
      })

      return id
    },
  },
}
</script>

<style lang="postcss" scoped>
.chat {
  &-container {
    @apply flex flex-col justify-end;

    &.has-shadow {
      box-shadow: 12px 12px 13px 0 rgba(0, 0, 0, 0.5);
    }

    &.is_visible {
      z-index: 40 !important;
    }
  }
}
</style>
